import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { waLink } from "@/lib/brand";

const faq = [
  {
    section: "Fees", icon: "💰",
    items: [
      { q: "What are the fees at Vikramshila Classes?", a: "Our standard fee is ₹999 per subject per month for all classes (VI–X). We also offer a special all-subjects bundle at ₹2,500 per month — a great value if your child needs 3 or more subjects. Crash courses and revision batches are priced separately — please contact us for details." },
      { q: "Are there any discounts?", a: "Yes, we offer sibling discounts and early-bird admission offers. Contact us on WhatsApp for current offers." },
    ],
  },
  {
    section: "Batch Timings", icon: "🕒",
    items: [
      { q: "What are your batch timings?", a: "Morning and evening batches are available. Timings are set based on school hours — typically 6:30–8:30 AM and 4:00–8:00 PM." },
      { q: "Can we choose our batch?", a: "Yes, subject to seat availability. Since we keep batches small, early enrollment is recommended." },
    ],
  },
  {
    section: "Online / Offline", icon: "💻",
    items: [
      { q: "Are classes online or offline?", a: "Primarily offline, at our Rajeev Nagar centre in Patna. Selected batches may have online support for revision and doubt-solving." },
      { q: "Do you provide recorded lectures?", a: "Yes — enrolled students get access to recorded revision sessions for tough chapters." },
    ],
  },
  {
    section: "Notes & Materials", icon: "📚",
    items: [
      { q: "Do you provide notes?", a: "Yes. Every student receives chapter-wise printed notes, worksheets, and sample papers included in the fee." },
      { q: "Are the notes based on CBSE or ICSE?", a: "Both. Notes are aligned with the student's board and school syllabus." },
    ],
  },
  {
    section: "Tests", icon: "📝",
    items: [
      { q: "How often are tests conducted?", a: "Weekly chapter tests + monthly cumulative tests + pre-board mock exams (for Class X)." },
      { q: "Do parents get test reports?", a: "Yes. Detailed performance reports are shared with parents every month." },
    ],
  },
  {
    section: "Doubts", icon: "❓",
    items: [
      { q: "Are doubt sessions included?", a: "Yes — dedicated doubt-solving classes are held every Saturday, plus one-on-one help on request." },
      { q: "Can students ask doubts on WhatsApp?", a: "Yes, we have a dedicated student WhatsApp group for quick doubt clarification." },
    ],
  },
  {
    section: "Admissions", icon: "🎓",
    items: [
      { q: "Is there an entrance test?", a: "No. Just book a free demo, meet our teachers, and if it's a good fit — enroll." },
      { q: "When can we enroll?", a: "Admissions are open year-round, subject to seat availability. New sessions typically start in April." },
    ],
  },
];

export default function FaqPage() {
  return (
    <div>
      <section className="bg-[#0B192C] text-white relative overflow-hidden">
        <div className="vk-grain" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <span className="vk-chip">FAQ</span>
          <h1 className="mt-4 font-display text-5xl sm:text-6xl font-800 tracking-tight max-w-3xl">Frequently asked questions.</h1>
          <p className="mt-5 max-w-2xl text-lg text-white/70">Everything about fees, timings, classes and admissions.</p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          {faq.map((g)=>(
            <div key={g.section}>
              <div className="flex items-center gap-3 mb-4">
                <div className="text-2xl">{g.icon}</div>
                <h2 className="font-display text-2xl font-800 text-[#0B192C]">{g.section}</h2>
              </div>
              <Accordion type="single" collapsible className="rounded-lg border border-slate-200 divide-y divide-slate-200">
                {g.items.map((it,i)=>(
                  <AccordionItem key={i} value={`${g.section}-${i}`} className="border-0">
                    <AccordionTrigger data-testid={`faq-${g.section}-${i}`} className="px-6 py-4 text-left font-medium text-[#0B192C] hover:no-underline hover:text-[#FF6B35]">
                      {it.q}
                    </AccordionTrigger>
                    <AccordionContent className="px-6 pb-4 text-slate-600 leading-relaxed">
                      {it.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
        </div>
      </section>

      <section className="py-16 bg-[#0B192C] text-white relative overflow-hidden">
        <div className="vk-grain" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display text-4xl font-800">Still have a question?</h2>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <a href={waLink()} target="_blank" rel="noreferrer" className="vk-btn-primary">WhatsApp Us Now <ArrowRight size={16} /></a>
            <Link to="/contact" className="vk-btn-outline">Contact Page</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
